import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./index.css"; // Ensure this imports your CSS
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles

import Pic1_2 from "../../../../ASSETS/IMAGES/Pic1_2x.webp";
import Pic2_2 from "../../../../ASSETS/IMAGES/Pic2_2x.webp";
import Pic3_2 from "../../../../ASSETS/IMAGES/Pic3_2x.webp";

const stepsData = [
  {
    id: 1,
    imgSrc: Pic1_2,
    title: "Clinical Setting",
    description:
      "KUR Diagnostics exams are always performed in clinics with a Physician's oversight.",
  },
  {
    id: 2,
    imgSrc: Pic2_2,
    title: "Advanced Equipment",
    description:
      "Advanced equipment such as specialized fundus cameras for digital retinal imaging, and more.",
  },
  //{
  //  id: 3,
  //  imgSrc: Pic3_2,
  //  title: "Venipuncture",
  //  description:
  //    "Blood draws are performed in-house by experienced phlebotomists.",
  //},
];

const StepsSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="content">
      <Container>
        <Row className="h-100 align-items-center">
          {stepsData.map((step) => (
            <Col
              key={step.id}
              xs={12}
              md={4}
              className="text-container"
              data-aos="fade-up"
            >
              <div className="stepCard">
                <img
                  src={step.imgSrc}
                  className="rounded-circle"
                  alt={step.title}
                  width="200"
                  height="200"
                />
                <p className="step_title">{step.title}</p>
                <p>{step.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default StepsSection;
